module.exports = __webpack_public_path__ + "img/scene_game.eebc44c2.webp";